import { useMutation, useQueryClient } from '@tanstack/react-query';
import inspectionApi from '../services/inspection.api';
import { inspectionKeys } from './useVehicleInspections';

const useUpdateVehicleInspection = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: inspectionApi.update,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: inspectionKeys.all });
      queryClient.invalidateQueries({
        queryKey: inspectionKeys.detail(variables.uuid),
      });
    },
  });
};

export default useUpdateVehicleInspection;
